import { CFG_EMP, SYSTEM_API_COMMON_CONFIG } from "../../util/constants";
import { getAccessTokenFromCookie } from "../../util/authentication";

export const getGOpsWorkgroups = async () => {
  const apiEndpoint =
    process.env.REACT_APP_SYSTEM_SERVICE_API +
    SYSTEM_API_COMMON_CONFIG +
    "/" +
    CFG_EMP.NAME +
    "/" +
    CFG_EMP.GO +
    "/" +
    CFG_EMP.WORKGROUP;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response.json();
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getGOpsWorkgroupsList = async () => {
  const apiEndpoint =
    process.env.REACT_APP_SYSTEM_SERVICE_API +
    SYSTEM_API_COMMON_CONFIG +
    "/" +
    CFG_EMP.NAME +
    "/" +
    CFG_EMP.GO +
    "/" +
    CFG_EMP.WORKGROUP +
    "/" +
    CFG_EMP.LIST;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response.json();
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getGOpsWorkgroup = async (workgroup) => {
  const apiEndpoint =
    process.env.REACT_APP_SYSTEM_SERVICE_API +
    SYSTEM_API_COMMON_CONFIG +
    "/" +
    CFG_EMP.NAME +
    "/" +
    CFG_EMP.GO +
    "/" +
    CFG_EMP.JOB_CODE +
    "/" +
    workgroup;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response.json();
  } catch (error) {
    console.log(error);
    return null;
  }
};
